<template>
    <div class="page-content" style="padding-bottom:10px !important;">
        <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
            <div class="my-2 d-flex">
                <div class="back-button-container">
                    <router-link :to="{
                        name: 'Integrations',
                        // query: {
                        //     // id: this.routeSearch ? encodeUrlComponent(this.routeSearch) : '',
                        //     // offset: this.routeOffset ? encodeUrlComponent(this.routeOffset) : '',
                        //     integrationName: this.routeIntegration ? encodeUrlComponent(this.routeIntegration) : '',
                        //     // filter: true,
                        // },
                    }" class="p-0" type="button">
                        <img src="../../../public/dashboard-assets/images/M2/BackButton.png" alt="Back Button"
                            style="margin-right: 10px;" />
                    </router-link>
                </div>
                <h3 class="mb-2 mb-md-0">{{ routeIntegration }}</h3>
            </div>
        </div>

        <div class="form-container">
            <form @submit.prevent="handleSubmit">
                <div class="form-row">
                    <div class="form-group">
                        <span class="form-label">PMaps Client Id</span>
                        <div v-if="clientsList.length === 1" class="form-control">
                            {{ clientsList[0].label }}
                        </div>

                        <vue3-select v-else style="width: 100%;" v-model="pmapsClientId" required :options="clientsList"
                            label="label" :reduce="option => option.id" placeholder="Select an option"
                            class="form-control p-0 border-none" @update:modelValue="handleClientSelectionChange" />
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <span class="form-label">Issuer <i class="info-icon bi bi-info-circle"
                                :data-description="ltiFieldDescriptions.issuer"></i></span>
                        <input v-model="issuer" type="text" class="form-control" required>
                    </div>
                    <div class="form-group">
                        <span class="form-label">Client Id <i class="info-icon bi bi-info-circle"
                                :data-description="ltiFieldDescriptions.clientId"></i></span>
                        <input v-model="clientId" type="text" class="form-control" required>
                    </div>


                </div>

                <div class="form-row">
                    <div class="form-group">
                        <span class="form-label">Jwks Url <i class="info-icon bi bi-info-circle"
                                :data-description="ltiFieldDescriptions.jwksUrl"></i></span>
                        <input v-model="jwksUrl" type="text" class="form-control" required>

                    </div>
                    <div class="form-group">
                        <span class="form-label">Authorization Endpoint <i class="info-icon bi bi-info-circle"
                                :data-description="ltiFieldDescriptions.authEndpoint"></i></span>
                        <input v-model="authEndpoint" type="text" class="form-control" required>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <span class="form-label">Token Endpoint <i class="info-icon bi bi-info-circle"
                                :data-description="ltiFieldDescriptions.tokenEndpoint"></i></span>
                        <input v-model="tokenEndpoint" type="text" class="form-control" required>
                    </div>

                    <div class="form-group">
                        <span class="form-label">Platform Name <i class="info-icon bi bi-info-circle"
                                :data-description="ltiFieldDescriptions.platformName"></i></span>
                        <input v-model="platformName" type="text" class="form-control" required>
                    </div>
                </div>
                <center v-if="pmapsClientId">
                    <button v-if="!isDataPresent" type="submit" class="btn btn-primary w-25"
                        :style="{ cursor: isFormNotValid ? 'not-allowed' : 'pointer' }"
                        :disabled="isFormNotValid">Submit</button>
                    <button v-else type="button" class="btn btn-primary w-25" @click="updateLTIData"
                        :style="{ cursor: isFormNotValid ? 'not-allowed' : 'pointer' }"
                        :disabled="isFormNotValid">Update</button>
                </center>

            </form>
        </div>

    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Vue3Select from "vue3-select";
import "vue3-select/dist/vue3-select.css";
export default {
    components: {
        Vue3Select
    },
    data() {
        return {
            issuer: '',
            clientId: '',
            jwksUrl: "",
            authEndpoint: '',
            tokenEndpoint: '',
            pmapsClientId: null,
            platformName: '',
            clientsList: [],
            integrationName: this.$route.params.integrationName,
            isDataPresent: false,
            getPMapsClientIdData: [],
            ltiFieldDescriptions: {
                issuer: "The unique URL that identifies the platform (e.g., LMS like Canvas). Usually like a domain, eg., https://lms.example.com",
                clientId: "A unique ID issued by the LMS when registering the PMaps LTI.",
                jwksUrl: "URL where the platform exposesits JSON Web Key Set (/jwks).",
                authEndpoint: "OAuth2 login URL usedto start the auth code flow. Usually ends with /authorize.",
                tokenEndpoint: "URL to exchange the auth codefor an access token. Usually ends with /token.",
                platformName: "A friendly name for the platform(e.g., Canvas, Moodle)."
            }
        };
    },
    created() {
        this.routeIntegration = this.$route.query.integration || '';
        this.PartnerList();
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
        isFormNotValid() {
            return this.issuer == '' || this.clientId == '' ||
                this.jwksUrl == '' || this.authEndpoint == '' || this.tokenEndpoint == '' ||
                this.platformName == '' || this.pmapsClientId == null
        }
    },
    methods: {
        ...mapActions([
            "AllPartnerList",
            "IntegrationLTI",
            "getpartner",
            "GetLTIPlatformData",
            "UpdateLTIPlatformData",
            "ShowWarningMessage"
        ]),
        async PartnerList() {
            var response = await this.getpartner({
                clientId: this.user.clientId,
            })
            const parentData = response?.object.data;

            var partners = await this.AllPartnerList({
                clientId: this.user.clientId,
                offset: 0,
                limit: -1,
            });

            const existingList = partners?.object?.data?.partnerData || [];

            const exists = existingList.some(
                existing => existing.clientId === parentData.clientId
            );

            this.clientsList = [
                ...(exists ? [] : [{
                    id: parentData.clientId,
                    label: `${parentData.clientId} - ${parentData.companyName}`
                }]),
                ...existingList.map(i => ({
                    id: i.clientId,
                    label: `${i.clientId} - ${i.company}`
                }))
            ];

        },
        async handleClientSelectionChange(newValue) {
            this.pmapsClientId = newValue;
            if (this.pmapsClientId != null) {
                var response = await this.GetLTIPlatformData({
                    pmapsClientId: parseInt(this.pmapsClientId)
                })

                if (response.status) {
                    this.isDataPresent = true;
                    this.getPMapsClientIdData = response.object.data
                    this.assignGetLTIData(this.getPMapsClientIdData);
                }
                else {
                    this.isDataPresent = false;
                    this.assignDefaultData();
                }
            }

        },
        assignGetLTIData(LTIData) {
            this.issuer = LTIData.issuer;
            this.clientId = LTIData.clientId;
            this.jwksUrl = LTIData.clientSecret;
            this.authEndpoint = LTIData.authUrl;
            this.tokenEndpoint = LTIData.tokenUrl;
            this.platformName = LTIData.platformName;
        },
        assignDefaultData() {
            this.issuer = '';
            this.clientId = '';
            this.jwksUrl = '';
            this.authEndpoint = '';
            this.tokenEndpoint = '';
            this.platformName = '';
        },
        async handleSubmit() {
            if (!this.isFormNotValid) {
                if (!this.checkEndpointValidations()) {
                    return;
                }
                await this.IntegrationLTI({
                    Issuer: this.issuer,
                    ClientId: this.clientId,
                    JwksUrl: this.jwksUrl,
                    AuthorizationEndpoint: this.authEndpoint,
                    TokenEndpoint: this.tokenEndpoint,
                    PMapsClientId: parseInt(this.pmapsClientId),
                    PlatFormName: this.platformName
                })
                this.assignDefaultData();
            }

        },
        async updateLTIData() {
            if (!this.checkEndpointValidations()) {
                return;
            }
            var response = await this.UpdateLTIPlatformData({
                ...this.getPMapsClientIdData,
                Issuer: this.issuer,
                ClientId: this.clientId,
                ClientSecret: this.jwksUrl,
                AuthorizationEndpoint: this.authEndpoint,
                TokenEndpoint: this.tokenEndpoint,
                PlatFormName: this.platformName
            })
            if (response.status) {
                const LTIData = response.object.data;
                this.assignGetLTIData(LTIData);
            }
        },
        checkEndpointValidations() {
            if (!this.jwksUrl.startsWith(this.issuer)) {
                this.ShowWarningMessage(`Incorrect Jwks Url, must start with ${this.issuer}`);
                return false;
            }
            if (!this.authEndpoint.startsWith(this.issuer)) {
                this.ShowWarningMessage(`Incorrect Authorization Endpoint, must start with ${this.issuer}`);
                return false;
            }
            if (!this.tokenEndpoint.startsWith(this.issuer)) {
                this.ShowWarningMessage(`Incorrect Token Endpoint, must start with ${this.issuer}`);
                return false;
            }
            return true;
        },


    }
};
</script>
<style scoped>
.tab-selector {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    background-color: #f1f0ff;
    margin: 24px 0px;
    padding: 8px 16px;
    border-radius: 5px;
    width: fit-content;
}

.tab-wrapper {
    flex: 1;
    text-align: center;
    padding-right: 15vw;
}

.tab-btn {
    padding: 5px 35px;
    border: none;
    cursor: pointer;
    font-size: 16px;
    background-color: #f1f0ff;
}

.tab-btn:hover {
    background-color: #4B2EEE;
    border-radius: 5px;
    color: white;
}

.tab-btn.active {
    background-color: #4B2EEE;
    border-radius: 5px;
    color: white;
}

.tab-btn.notactive {
    background-color: #4B2EEE;
    border-radius: 5px;
    color: white;
}

.disabled-button {
    cursor: not-allowed !important;
}

.form-container {
    width: 100%;
    margin: 20px auto;
    padding: 20px;
    background-color: rgb(238, 236, 236);
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-row {
    display: flex;
    gap: 20px;
    margin-bottom: 15px;
}

.form-group {
    flex: 1;
    position: relative;
}

.form-label {
    display: inline-block;
}

.form-control {
    width: 100%;
    padding: 7px;
    border: 2px solid #ccc;
    border-radius: 6px;
    box-sizing: border-box;
}

.btn-primary {
    background-color: #007bff;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.btn-primary:hover {
    background-color: #0056b3;
}

.info-icon {
    display: inline-block;
    color: #a1a1a1;
    margin-left: 5px;
    cursor: pointer;
    vertical-align: middle;
    font-size: 1rem;
    transition: opacity 0.2s;
    position: relative;
}

.info-icon:hover:after {
    content: attr(data-description);
    position: absolute;
    background-color: #333;
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 12px;
    width: 350px;
    white-space: wrap;
    z-index: 1000;
    top: 20px;
    left: -4vw;
    pointer-events: none;
}
</style>